export default __webpack_public_path__ + "05632c3df05627ef556626cb84403493.png";